import { render } from "./HeaderCart.vue?vue&type=template&id=703030b4&scoped=true"
import script from "./HeaderCart.vue?vue&type=script&lang=js"
export * from "./HeaderCart.vue?vue&type=script&lang=js"

import "./HeaderCart.vue?vue&type=style&index=0&id=703030b4&scoped=true&lang=less"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703030b4"]])

export default __exports__